import { AppConfig } from '@wetransfer/transfer/core-bundle/config/app-config';
import { getDefaultCookieDomain } from '@wetransfer/transfer/helper/cookies';
import Analytics from '@wetransfer/transfer/modules/analytics';
import Cookie from '@wetransfer/transfer/modules/concorde-cookie';

export const defaultSettings = {
  id: AppConfig.termsAndConditions.consentId,
  version: AppConfig.termsAndConditions.consentVersion,
  name: AppConfig.cookies.termsAndConditions.name,
  durationInDays: 365,
  domain: getDefaultCookieDomain(),
};

// Module state
let settings = {
  ...defaultSettings,
  validCookieValue: `${defaultSettings.version}:${defaultSettings.id}`,
};

const TermsAndConditions = {
  settings,

  configure,

  accept,
  areAccepted,
};

/**
 * Configure Terms And Conditions
 * @param    {Object}   [opts=defaultSettings]       Configuration
 * @property {String}   [opts.id]                    Consent document ID
 * @property {String}   [opts.version]               Consent document version
 * @property {Boolean}  [opts.name]                  Consent document name
 * @property {Number}   [opts.durationInDays]        Cookie expiration
 * @property {String}   [opts.domain=wetransfer.com] The platform domain
 */
function configure(opts = {}) {
  settings = {
    ...settings,
    ...opts,
  };

  // On start-up we check a previous acceptance and handle it.
  if (areAccepted()) {
    trackAccepted();
  }
}

/**
 * Accept the Terms And Conditions
 */
function accept() {
  setCookie();
  trackAccepted();
}

function areAccepted() {
  const cookie = getCookie();

  let accepted = false;

  if (cookie === settings.validCookieValue) {
    accepted = true;
  } else if (cookie === '1' || cookie === settings.version) {
    // if cookie lacks `id:version` format, reset it and approve it
    setCookie();
    accepted = true;
  }

  return accepted;
}

function trackAccepted() {
  Analytics.trackTermsAccepted({
    id: settings.id,
    version: settings.version,
    name: settings.name,
  });
}

function setCookie() {
  Cookie.set(settings.name, settings.validCookieValue, {
    days: settings.durationInDays,
    domain: settings.domain,
  });
}

function getCookie() {
  return Cookie.get(settings.name);
}

export default TermsAndConditions;
